export default class Principal {

    public pdoId: KnockoutObservable<string>;
    public name: KnockoutObservable<string>;
    public fullName: KnockoutObservable<string>;
    public logoUrl: KnockoutObservable<string>;
    public defaultCurrencyId: KnockoutObservable<number>;

    constructor() {
        this.pdoId = ko.observable();
        this.name = ko.observable();
        this.fullName = ko.observable();
        this.logoUrl = ko.observable();
        this.defaultCurrencyId = ko.observable();
    }

    /**
     * Setzt Mandanteninformationen
     */
    public setPrincipalInfo(principalInfo) {
        if (principalInfo == null) {
            principalInfo = { pdoId: 0, name: "", fullName: "WithoutPrincipal", logoUrl: "", defaultCurrencyID: 0 };
        }

        this.pdoId(principalInfo.pdoId);
        this.name(principalInfo.name);
        this.fullName(principalInfo.fullName);
        this.logoUrl(principalInfo.logoUrl);
        this.defaultCurrencyId(principalInfo.defaultCurrencyID);
    }
}